module.exports = __webpack_public_path__ + "static/media/ci.02796bef.svg";